module.exports = __webpack_public_path__ + "media/fonts/ABC_Weise_Regular_201014-a11e12dd387ffb1509708a2c06726a76.woff";